import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, CheckCircle, Clock, Headphones, MessageSquare } from 'lucide-react';

export default function Contacto() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    empresa: '',
    mensaje: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para enviar el formulario
    console.log('Formulario enviado:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        nombre: '',
        email: '',
        telefono: '',
        empresa: '',
        mensaje: ''
      });
    }, 3000);
  };

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center py-12 md:py-20"
        style={{ 
          backgroundImage: 'url(https://images.unsplash.com/photo-1668681919287-7367677cdc4c?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/92 via-allti-blue/88 to-gray-900/92"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-hpe-green/20 backdrop-blur-sm px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-hpe-green/30 mb-4 md:mb-6">
              <Headphones className="w-3 h-3 md:w-4 md:h-4 text-hpe-green" />
              <span className="text-xs md:text-sm font-medium text-white">Respuesta en menos de 24 horas</span>
            </div>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6" data-testid="contacto-title">
              Hablemos de tu<br />
              <span className="text-allti-blue">Proyecto</span>
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 md:mb-10 max-w-3xl mx-auto">
              Nuestro equipo de expertos está listo para ayudarte a transformar tu infraestructura TI 
              con soluciones HPE de última generación.
            </p>

            {/* Contact Highlights */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 border border-white/20">
                <Clock className="w-6 h-6 md:w-8 md:h-8 text-allti-blue mx-auto mb-2 md:mb-3" />
                <h3 className="text-white font-semibold mb-1 md:mb-2 text-sm md:text-base">Respuesta Rápida</h3>
                <p className="text-xs md:text-sm text-gray-200">Contestamos en menos de 24 horas</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 border border-white/20">
                <MessageSquare className="w-6 h-6 md:w-8 md:h-8 text-hpe-green mx-auto mb-2 md:mb-3" />
                <h3 className="text-white font-semibold mb-1 md:mb-2 text-sm md:text-base">Consultoría Gratuita</h3>
                <p className="text-xs md:text-sm text-gray-200">Primera asesoría sin costo</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 md:p-6 border border-white/20">
                <Headphones className="w-6 h-6 md:w-8 md:h-8 text-yellow-400 mx-auto mb-2 md:mb-3" />
                <h3 className="text-white font-semibold mb-1 md:mb-2 text-sm md:text-base">Soporte 24/7</h3>
                <p className="text-xs md:text-sm text-gray-200">Disponibles cuando nos necesites</p>
              </div>
            </div>

            {/* Main CTA */}
            <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4">
              <a 
                href="#form" 
                className="bg-allti-blue text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg hover:bg-blue-600 transition shadow-lg shadow-allti-blue/50 text-sm md:text-base"
              >
                Completar Formulario
              </a>
              <a 
                href="tel:+525512345678" 
                className="bg-white/10 backdrop-blur-sm text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg hover:bg-white/20 transition border border-white/30 flex items-center justify-center gap-2 text-sm md:text-base"
              >
                <Phone className="w-4 h-4" />
                Llamar Ahora
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="form" className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Información de contacto */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Información de Contacto</h2>
              <p className="text-lg text-gray-600 mb-8">
                Nuestro equipo de expertos está listo para asesorarte y diseñar la solución perfecta para tu empresa.
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4" data-testid="contact-email">
                  <div className="bg-allti-blue/10 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="text-allti-blue" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                    <p className="text-gray-600">yserraldeo@allti.mx</p>
                    <p className="text-gray-600">lgarcia@allti.mx</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-testid="contact-phone">
                  <div className="bg-allti-red/10 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="text-allti-red" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Teléfono</h3>
                    <p className="text-gray-600">+52 (55) 9000 5568</p>
                    <p className="text-gray-600">+52 (999) 3323 3958 </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4" data-testid="contact-address">
                  <div className="bg-hpe-green/10 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="text-hpe-green" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Oficinas</h3>
                    <p className="text-gray-600">Montectio 38, P7 OF 17, WTC</p>
                    <p className="text-gray-600">Benito Juarez, 03810</p>
                    <p className="text-gray-600">Ciudad de México, México</p>
                  </div>
                </div>
              </div>

              <div className="mt-10">
                <img 
                  src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzYxMDcxODQ2fDA&ixlib=rb-4.1.0&q=85"
                  alt="Oficinas ALLTI"
                  className="rounded-xl shadow-2xl"
                />
              </div>
            </div>

            {/* Formulario */}
            <div>
              <div className="bg-gray-50 p-8 rounded-xl shadow-lg">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Envíanos un Mensaje</h2>
                
                {submitted ? (
                  <div className="bg-hpe-green/10 border border-hpe-green rounded-lg p-6 text-center" data-testid="success-message">
                    <CheckCircle className="text-hpe-green mx-auto mb-4" size={48} />
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">¡Mensaje Enviado!</h3>
                    <p className="text-gray-600">Nos pondremos en contacto contigo pronto.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
                    <div>
                      <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-2">
                        Nombre Completo *
                      </label>
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        data-testid="input-nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-allti-blue focus:border-transparent outline-none transition"
                        placeholder="Juan Pérez"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                        Email *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        data-testid="input-email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-allti-blue focus:border-transparent outline-none transition"
                        placeholder="juan.perez@empresa.com"
                      />
                    </div>

                    <div>
                      <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-2">
                        Teléfono
                      </label>
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        data-testid="input-telefono"
                        value={formData.telefono}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-allti-blue focus:border-transparent outline-none transition"
                        placeholder="+52 55 1234 5678"
                      />
                    </div>

                    <div>
                      <label htmlFor="empresa" className="block text-sm font-semibold text-gray-700 mb-2">
                        Empresa
                      </label>
                      <input
                        type="text"
                        id="empresa"
                        name="empresa"
                        data-testid="input-empresa"
                        value={formData.empresa}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-allti-blue focus:border-transparent outline-none transition"
                        placeholder="Tu Empresa S.A."
                      />
                    </div>

                    <div>
                      <label htmlFor="mensaje" className="block text-sm font-semibold text-gray-700 mb-2">
                        Mensaje *
                      </label>
                      <textarea
                        id="mensaje"
                        name="mensaje"
                        data-testid="input-mensaje"
                        value={formData.mensaje}
                        onChange={handleChange}
                        required
                        rows="4"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-allti-blue focus:border-transparent outline-none transition resize-none"
                        placeholder="Cuéntanos sobre tu proyecto o necesidad..."
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      data-testid="submit-btn"
                      className="w-full bg-allti-red text-white px-6 py-4 rounded-lg hover:bg-red-800 transition-colors text-lg font-semibold flex items-center justify-center space-x-2"
                    >
                      <span>Enviar Mensaje</span>
                      <Send size={20} />
                    </button>
                  </form>
                )}
              </div>

              <p className="text-sm text-gray-500 mt-4 text-center">
                * Campos obligatorios
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Visítanos</h2>
            <p className="text-xl text-gray-600">
              Estamos ubicados en el corazón de la Ciudad de México
            </p>
          </div>
          <div className="bg-gray-300 h-96 rounded-xl flex items-center justify-center">
            <p className="text-gray-600 text-lg">[ Mapa de ubicación ]</p>
          </div>
        </div>
      </section>
    </div>
  );
}